import { jsx } from 'react/jsx-runtime';

var Selected = function Selected() {
  return /*#__PURE__*/jsx("svg", {
    "aria-hidden": true,
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M0 12C0 5.374 5.372 0 12 0s12 5.374 12 12c0 6.628-5.372 12-12 12S0 18.628 0 12Zm7.47.031 3.53 3.53 5.53-5.53-1.06-1.061L11 13.44l-2.47-2.47-1.06 1.061Z",
      clipRule: "evenodd"
    })
  });
};

export { Selected as default };
//# sourceMappingURL=Scelected.js.map
